// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8999) return "static/chunks/8999-188775c544905be6.js";
	if (chunkId === 7003) return "static/chunks/7003-aeb8f3e23ab4f47c.js";
	if (chunkId === 8018) return "static/chunks/8018-31d7fdba0ded0245.js";
	if (chunkId === 2673) return "static/chunks/2673-16aea50a11326cb2.js";
	if (chunkId === 3818) return "static/chunks/3818-c23debd4302395d5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"919":"580b692b34a76020","1203":"df9fc8fb9fce96ac","3734":"4b95d562281b5e57","4034":"226f05f54291a4c9","5936":"cffe19b18d4a3553","8021":"639a78d1446dfcd9","9894":"8d6a6d063cf2d940"}[chunkId] + ".js";
};